import React from 'react';
import { StatusCell } from './cells/StatusCell';
import { PeopleCell } from './cells/PeopleCell';
import { DateCell } from './cells/DateCell';
import { NumbersCell } from './cells/NumbersCell';
import { TimelineCell } from './cells/TimelineCell';
import { CheckboxCell } from './cells/CheckboxCell';
import { DropdownCell } from './cells/DropdownCell';
import { LongTextCell } from './cells/LongTextCell';
import { TextCell } from './cells/TextCell';
import { FilesCell } from './cells/FilesCell';
import { LinkCell } from './cells/LinkCell';
import { EmailCell } from './cells/EmailCell';
import { PhoneCell } from './cells/PhoneCell';
import { LocationCell } from './cells/LocationCell';
import { RatingCell } from './cells/RatingCell';
import { ProgressCell } from './cells/ProgressCell';
import { WorldClockCell } from './cells/WorldClockCell';
import { ItemIdCell } from './cells/ItemIdCell';
import { TagsCell } from './cells/TagsCell';
import { FormulaCell } from './cells/FormulaCell';
import { AutoNumberCell } from './cells/AutoNumberCell';
import { CreationLogCell } from './cells/CreationLogCell';
import { LastUpdatedCell } from './cells/LastUpdatedCell';
import { ColorPickerCell } from './cells/ColorPickerCell';
import { CountryCell } from './cells/CountryCell';
import { WeekCell } from './cells/WeekCell';
import { VoteCell } from './cells/VoteCell';

interface CellRendererProps {
  columnType: string;
  value: string;
  config?: any;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

export const CellRenderer: React.FC<CellRendererProps> = ({
  columnType,
  value,
  config,
  onChange,
  readOnly = false,
}) => {
  // Parse value se for JSON
  let parsedValue = value;
  try {
    if (value && typeof value === 'string' && (value.startsWith('{') || value.startsWith('['))) {
      parsedValue = JSON.parse(value);
    }
  } catch (e) {
    // Keep as string
  }

  switch (columnType) {
    case 'Status':
      return <StatusCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    case 'Person':
    case 'People':
      return <PeopleCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    case 'Date':
      return <DateCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    case 'Numbers':
      return <NumbersCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    case 'Timeline':
      return <TimelineCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    case 'Checkbox':
      return <CheckboxCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    case 'Dropdown':
      return <DropdownCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    case 'Long Text':
      return <LongTextCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
    
    // FASE 2 - SUPER USEFUL
    case 'Files':
      return <FilesCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Link':
      return <LinkCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Email':
      return <EmailCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Phone':
      return <PhoneCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Location':
      return <LocationCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Rating':
      return <RatingCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Progress Tracking':
      return <ProgressCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'World Clock':
      return <WorldClockCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Item ID':
      return <ItemIdCell value={parsedValue} readOnly={readOnly} />;
    
    case 'Tags':
    
    // FASE 3 - ADVANCED FEATURES
    case 'Formula':
      return <FormulaCell value={parsedValue} readOnly={true} />;
    
    case 'Auto Number':
      return <AutoNumberCell value={parsedValue} config={config} readOnly={true} />;
    
    case 'Creation Log':
      return <CreationLogCell value={parsedValue} readOnly={true} />;
    
    case 'Last Updated':
      return <LastUpdatedCell value={parsedValue} readOnly={true} />;
    
    case 'Color Picker':
      return <ColorPickerCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Country':
      return <CountryCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Week':
      return <WeekCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Vote':
      return <VoteCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
      return <TagsCell value={parsedValue} onChange={onChange} readOnly={readOnly} />;
    
    case 'Text':
    default:
      return <TextCell value={parsedValue} config={config} onChange={onChange} readOnly={readOnly} />;
  }
};
